import { render, staticRenderFns } from "./CooperationPage.vue?vue&type=template&id=502c1512&scoped=true"
import script from "./CooperationPage.vue?vue&type=script&lang=js"
export * from "./CooperationPage.vue?vue&type=script&lang=js"
import style0 from "./CooperationPage.vue?vue&type=style&index=0&id=502c1512&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502c1512",
  null
  
)

export default component.exports